import { useState, useCallback } from 'react';

// ----------------------------------------------------------------------

// Call sites pass the raw API rows, and the URL column is named differently per endpoint:
// `src` (formattedImages), `file` (getAllFiles), `image_url` (getSharedImagesByToken).
const URL_KEYS = ['src', 'poster', 'image_url', 'file'];

export default function useLightBox(slides) {
  const [selected, setSelected] = useState(-1);

  const handleOpen = useCallback(
    (slideUrl) => {
      // A missing url used to match the first row whose key was also undefined (any video,
      // since `poster` is rarely populated), silently opening the wrong slide.
      if (!slideUrl || !Array.isArray(slides)) {
        setSelected(-1);
        return;
      }

      const slideIndex = slides.findIndex((slide) =>
        URL_KEYS.some((key) => slide?.[key] && slide[key] === slideUrl)
      );

      setSelected(slideIndex);
    },
    [slides]
  );

  const handleClose = useCallback(() => {
    setSelected(-1);
  }, []);

  return {
    selected,
    open: selected >= 0,
    onOpen: handleOpen,
    onClose: handleClose,
    setSelected,
  };
}
